import React from "react";

// icons
import {
  PlaneIcon,
  ChinaIcon,
  ShipIcon,
  GroundIcon,
  TurkeyIcon,
  UsaIcon,
  GreeceIcon,
  GermanyIcon,
  EnglandIcon,
  UkraineIcon,
  GeorgiaIcon,
  IndiaIcon,
  SpainIcon,
  PolandIcon,
} from "@/components/assets/icons";

import UsaImage from "@/components/assets/images/usa.png";
import TurkeyImage from "@/components/assets/images/turkey.png";
import ChinaImage from "@/components/assets/images/china.png";
import GreeceImage from "@/components/assets/images/greece.png";
import EnglangImage from "@/components/assets/images/england.png";
import GermanyImage from "@/components/assets/images/germany.png";
import UkraineImage from "@/components/assets/images/ukraine.png";
import IndiaImage from "@/components/assets/images/india.png";
import PolandImage from "@/components/assets/images/poland.png";
import GeorgiaImage from "@/components/assets/images/georgia.png";
import SpainImage from "@/components/assets/images/spain.png";

// shop images
import Ebay from "@/components/assets/images/shop-images/ebay.png";
import Hm from "@/components/assets/images/shop-images/hm.png";
import Levis from "@/components/assets/images/shop-images/levis.png";
import Amazon from "@/components/assets/images/shop-images/amazon.png";
import SixPm from "@/components/assets/images/shop-images/6pm.png";
import Apple from "@/components/assets/images/shop-images/apple.png";
import Etsy from "@/components/assets/images/shop-images/etsy.png";
import Temu from "@/components/assets/images/shop-images/temu.png";
import Waikiki from "@/components/assets/images/shop-images/waikiki.png";
import Zara from "@/components/assets/images/shop-images/zara.png";
import Universal from "@/components/assets/images/shop-images/universal-shop-icon.png";

// parcel category icons

import { Country, Shop, TransportationMode } from "@/enums";

export const renderCountryImage: Record<Country, any> = {
  [Country.UKRAINE]: UkraineImage,
  [Country.USA]: UsaImage,
  [Country.TURKEY]: TurkeyImage,
  [Country.GEORGIA]: GeorgiaImage,
  [Country.CHINA_AIR]: ChinaImage,
  [Country.CHINA_LAND]: ChinaImage,
  [Country.GREECE]: GreeceImage,
  [Country.GERMANY]: GermanyImage,
  [Country.INDIA]: IndiaImage,
  [Country.SPAIN]: SpainImage,
  [Country.POLAND]: PolandImage,
  [Country.ENGLAND]: EnglangImage,
};

export const renderCountryIcon: Record<Country, any> = {
  [Country.UKRAINE]: UkraineIcon,
  [Country.USA]: UsaIcon,
  [Country.TURKEY]: TurkeyIcon,
  [Country.GEORGIA]: GeorgiaIcon,
  [Country.CHINA_AIR]: ChinaIcon,
  [Country.CHINA_LAND]: ChinaIcon,
  [Country.GREECE]: GreeceIcon,
  [Country.ENGLAND]: EnglandIcon,
  [Country.GERMANY]: GermanyIcon,
  [Country.INDIA]: IndiaIcon,
  [Country.SPAIN]: SpainIcon,
  [Country.POLAND]: PolandIcon,
};

export const renderShopIcon: Record<Shop, any> = {
  [Shop.EBAY]: Ebay,
  [Shop.HM]: Hm,
  [Shop.LEVIS]: Levis,
  [Shop.AMAZON]: Amazon,
  [Shop.SIXPM]: SixPm,
  [Shop.APPLE]: Apple,
  [Shop.ETSY]: Etsy,
  [Shop.TEMU]: Temu,
  [Shop.WAIKIKI]: Waikiki,
  [Shop.ZARA]: Zara,
  [Shop.UNIVERSAL]: Universal,
};

export const renderTransportationIcon: Record<
  TransportationMode,
  React.ReactNode
> = {
  [TransportationMode.SEA]: <ShipIcon />,
  [TransportationMode.AIR]: <PlaneIcon />,
  [TransportationMode.GROUND]: <GroundIcon />,
  [TransportationMode.ECONOMY]: <ShipIcon />,
};
